import { render, staticRenderFns } from "./educationResult.vue?vue&type=template&id=3f5dbfcb"
import script from "./educationResult.vue?vue&type=script&lang=js"
export * from "./educationResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f5dbfcb')) {
      api.createRecord('3f5dbfcb', component.options)
    } else {
      api.reload('3f5dbfcb', component.options)
    }
    module.hot.accept("./educationResult.vue?vue&type=template&id=3f5dbfcb", function () {
      api.rerender('3f5dbfcb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/edu/result/educationResult.vue"
export default component.exports